
import usePropModel from '#/usePropModel'

import { defineComponent, computed, PropType, watch } from 'vue'
import { is, map, update, either, find, isEmpty } from 'ramda'
import { isShort } from 'geri'

import Field from './Field.vue'

export default defineComponent({
	name: 'SelectField',

	components: {
		Field
	},

	props: {
		value: { type: [Number, String], default: '' },
		options: { type: Array as PropType<(string|number|Option)[]>, default: () => [] },
		noAutoPick: { type: Boolean, default: false }
	},

	setup (props, { emit }) {
		const model = usePropModel(props, emit)
		const findSelected = find((i: Option) => i?.selected ?? false)
		const items = computed<Option[]>(() => {
			const ifPrimary  = (i: number|string): Option => ({ text: `${i}`, value: i })
			const toOption   = (i: string|number|Option): Option => either(is(String), is(Number))(i) ? ifPrimary(i as number|string) : (i as Option)

			const options = map(toOption)(props.options)
			
			return (
				isShort(options)||props.noAutoPick||(findSelected(options) ?? false)
					? options 
					: update(0, { ...options[0], selected: true }, options) 
			) 
		})

		watch(() => props.options, () => {
			if (isEmpty(model.value)) {
				model.value = (findSelected(items.value)?.value) ?? ''
			}
		})

		return { model, items }
	}
})
